
import { client } from '@/common-utils/libraries/axios/axios';
import SIM_CARD from '../apiUrls';

const mutationActivateSimCard = (onSuccess, onError) => {
    return {
        mutationFn: ({ uuids, offer }) => {
            return client.post(SIM_CARD.ACTIVATE.url, { uuids, offer });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationActivateSimCard;